var _defs, _path, _path2, _g, _g2, _g3, _path3, _path4, _g4, _g5, _g6, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _g7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDbbot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{clip-path:url(#clippath);}.cls-2{fill:none;}.cls-2,.cls-3,.cls-4{stroke-width:0px;}.cls-5{clip-path:url(#clippath-1);}.cls-6{clip-path:url(#clippath-4);}.cls-7{clip-path:url(#clippath-3);}.cls-8{clip-path:url(#clippath-2);}.cls-9{clip-path:url(#clippath-6);}.cls-10{clip-path:url(#clippath-5);}.cls-3{fill-rule:evenodd;}.cls-3,.cls-4{fill:#4924ce;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 36.86,
    y: 18.56,
    width: 9.84,
    height: 9.63
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.04,
    y: 43.93,
    width: 6.2,
    height: 13.78
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 70.31,
    y: 43.93,
    width: 5.91,
    height: 13.78
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 116.02,
    y: 24.1,
    width: 20.76,
    height: 13.43
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 116.02,
    y: 42.37,
    width: 20.76,
    height: 14.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 116.02,
    y: 63.37,
    width: 20.76,
    height: 13.88
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 83.64,
    y: 32.69,
    width: 29.15,
    height: 35.52
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m31.79,30.91h20.26c5.57,0,10.62,2.28,14.29,5.94,3.67,3.67,5.94,8.73,5.94,14.29s-2.28,10.63-5.94,14.3c-3.67,3.67-8.73,5.94-14.29,5.94h-2.21l-11.23,10.47c-1.01.94-2.61.88-3.55-.13-.45-.48-.68-1.1-.68-1.71v-8.63h-2.58c-5.57,0-10.62-2.28-14.29-5.94s-5.94-8.73-5.94-14.3,2.28-10.62,5.94-14.29c3.67-3.67,8.73-5.94,14.29-5.94Zm20.26,5.04h-20.26c-4.17,0-7.97,1.71-10.73,4.47s-4.47,6.56-4.47,10.73,1.71,7.98,4.47,10.74c2.76,2.75,6.56,4.47,10.73,4.47h5.1c1.39,0,2.52,1.12,2.52,2.51v5.37l7.61-7.1c.46-.49,1.11-.79,1.83-.79h3.2c4.17,0,7.98-1.71,10.73-4.47s4.47-6.56,4.47-10.74-1.71-7.98-4.47-10.73c-2.75-2.76-6.56-4.47-10.73-4.47Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m40.21,23.3h3.42v10.39h-3.42v-10.39Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m41.92,18.58c2.48,0,4.48,2.01,4.48,4.48s-2.01,4.49-4.48,4.49-4.49-2.01-4.49-4.49,2.01-4.48,4.49-4.48Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m13.02,57.13c-3.31,0-5.98-2.68-5.98-5.99s2.68-5.98,5.98-5.98v11.97Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m70.91,57.13c3.31,0,5.98-2.68,5.98-5.99s-2.68-5.98-5.98-5.98v11.97Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m33.72,43.99c1.46,0,2.66,1.2,2.66,2.66v8.05c0,1.47-1.2,2.66-2.66,2.66s-2.66-1.19-2.66-2.66v-8.05c0-1.46,1.2-2.66,2.66-2.66Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m50.12,43.99c1.46,0,2.66,1.2,2.66,2.66v8.05c0,1.47-1.2,2.66-2.66,2.66s-2.66-1.19-2.66-2.66v-8.05c0-1.46,1.2-2.66,2.66-2.66Z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m136.13,27.16c-.16-.24-.44-.38-.73-.38h-4.64l-.67-2.03c-.12-.36-.45-.6-.83-.6h-12.28c-.26,0-.5.11-.67.3-.16.2-.24.45-.2.71l1.75,11.4h0c.02.13.06.25.14.36.16.24.44.38.73.38h13.16c.36,0,.68-.21.81-.55l3.51-8.77c.11-.27.08-.57-.09-.82Zm-18.13-1.26h10.63l.29.88h-6.68c-.36,0-.68.22-.81.56l-2.31,5.78-1.11-7.22Zm13.3,9.65h-11.27l2.81-7.02h11.27l-2.81,7.02Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m136.13,46.46c-.16-.24-.44-.38-.73-.38h-4.64l-.67-2.03c-.12-.36-.45-.6-.83-.6h-12.28c-.26,0-.5.11-.67.31-.16.19-.24.45-.2.7l1.75,11.41h0c.02.12.06.25.14.35.16.25.44.38.73.38h13.16c.36,0,.68-.21.81-.55l3.51-8.77c.11-.27.08-.57-.09-.82Zm-18.13-1.26h10.63l.29.88h-6.68c-.36,0-.68.22-.81.56l-2.31,5.79-1.11-7.22Zm13.3,9.65h-11.27l2.81-7.01h11.27l-2.81,7.01Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m132.71,76.23l3.51-8.77c.11-.26.08-.57-.09-.81-.16-.25-.44-.38-.73-.38h-4.64l-.67-2.04c-.12-.36-.45-.6-.83-.6h-12.28c-.26,0-.5.11-.67.31s-.24.45-.2.7l1.75,11.41h0c.02.13.06.25.14.35.16.25.44.39.73.39h13.16c.36,0,.68-.22.81-.56Zm-14.7-10.86h10.63l.29.88h-6.68c-.36,0-.68.21-.81.55l-2.31,5.79-1.11-7.22Zm2.02,9.66l2.81-7.02h11.27l-2.81,7.02h-11.27Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m96.8,29.41h1.76v1.76h-1.76v-1.76Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m96.8,25.9h1.76v1.75h-1.76v-1.75Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m100.31,25.9h1.75v1.75h-1.75v-1.75Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m103.82,25.9h1.75v1.75h-1.75v-1.75Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m107.33,25.9h1.75v1.75h-1.75v-1.75Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m110.84,25.9h1.75v1.75h-1.75v-1.75Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m96.8,69.77h1.76v1.75h-1.76v-1.75Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m96.8,73.27h1.76v1.76h-1.76v-1.76Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m100.31,73.27h1.75v1.76h-1.75v-1.76Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m103.82,73.27h1.75v1.76h-1.75v-1.76Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m107.33,73.27h1.75v1.76h-1.75v-1.76Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m110.84,73.27h1.75v1.76h-1.75v-1.76Z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m97.67,68.01c6.19,0,12.42-1.75,13.89-3.89.1-.15.15-.32.15-.5v-25c0-3.7-7.23-5.7-14.04-5.7s-14.03,2-14.03,5.7v25c0,.18.05.35.15.5,1.55,2.25,7.38,3.89,13.88,3.89Zm0-33.34c7.61,0,12.29,2.3,12.29,3.95s-4.67,3.95-12.29,3.95-12.28-2.3-12.28-3.95,4.67-3.95,12.28-3.95Zm-12.28,6.81c2.55,1.85,7.52,2.84,12.28,2.84s9.73-.98,12.29-2.84v4.59c0,1.65-4.67,3.95-12.29,3.95s-12.28-2.3-12.28-3.95v-4.59Zm0,7.46c2.55,1.86,7.52,2.84,12.28,2.84s9.73-.98,12.29-2.84v6.04c-1.31,1.46-6.36,2.95-12.29,2.95s-10.97-1.49-12.28-2.95v-6.04Zm0,8.22c2.54,1.51,7.2,2.51,12.28,2.51s9.75-1,12.29-2.51v6.15c-1.22,1.29-6.2,2.95-12.29,2.95s-10.96-1.49-12.28-2.94v-6.16Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDbbot);
export default __webpack_public_path__ + "static/media/dbbot.81a29f40daff3f0d3873eccc3bd9c99a.svg";
export { ForwardRef as ReactComponent };